import { Steps } from 'antd';
import React from 'react';
import './style.less';
import InvoiceStepType from './StepType';
import InvoiceStepConfiguration from './StepConfiguration';
import InvoiceStepRecipient from './StepRecipient';

const steps = [
  { title: 'Tipo de nota', content: <InvoiceStepType /> },
  { title: 'Configuração', content: <InvoiceStepConfiguration /> },
  { title: 'Destinatário', content: <InvoiceStepRecipient /> },
];

interface Props {
  current: number;
  onStepChange(current: number): void;
}

const InvoiceCreateSteps: React.FC<Props> = ({ current, onStepChange }) => {
  return (
    <div className="invoice-create-steps">
      <Steps
        current={current}
        onChange={onStepChange}
        className="invoice-create-steps-info"
      >
        {steps.map((step, index) => (
          <Steps.Step key={index} title={step.title} />
        ))}
      </Steps>

      {steps.map((step, index) => (
        <div
          key={index}
          className="invoice-create-steps-content"
          data-active={index === current}
        >
          {step.content}
        </div>
      ))}
    </div>
  );
};

export default InvoiceCreateSteps;
